import '../../App.scss';
import { NavLink, useNavigate } from 'react-router-dom';
import pseuds from '../../data/pseuds.json'

function calculateColor(score) {
	// returns the bird type 
	if (score >= 50) {
		return ['score-green']
	} else if (score >= 43) {
		return 'score-yellow'
	} else if (score >= 36) {
		return 'score-orange'
	} else {
		return 'score-red'
	}
}

function btString(biasTags) {
	var tagString = "";
	for (let t of biasTags) {
		tagString += t; 
		tagString += ", ";
	}
	return tagString.slice(0, tagString.length - 2);
}

export default function AtAGlance(props) {

	var title = props.reviewer1.propertyNameOriginal;
	if (props.reviewer1.mediaType === "serial") {
		var seasonNumber = (props.reviewer1.mediaId ? props.reviewer1.mediaId : 1);
		title += " (Season " + seasonNumber + ")";
	}

	var rev1 = props.reviewer1.yourPseudonym ? props.reviewer1.yourPseudonym : props.reviewer1.tagger;
	for (var p of pseuds.pseuds) {
		if (p[0] === rev1) 
			rev1 = p[1];
	}


	rev1 = "Reviewed by <b>" + rev1 + "</b>";
	

	var quote1 = "<i>Quote forthcoming.</i>"; 
	if (props.reviewer1.pullQuoteFromBlurb !== "") {
		quote1 = props.reviewer1.pullQuoteFromBlurb;
	}

	var rev2 = "<i>Review forthcoming.</i>";
	var quote2 = "<i>Quote forthcoming.</i>";
	
	if (props.reviewer2) {
		var rev2 = props.reviewer2.yourPseudonym ? props.reviewer2.yourPseudonym : props.reviewer2.tagger;
		for (var p of pseuds.pseuds) {
			if (p[0] === rev2) 
				rev2 = p[1];
		}
		if (props.reviewer2.pullQuoteFromBlurb !== "") {
			quote2 = props.reviewer2.pullQuoteFromBlurb;
		}
	}

	rev2 = "<p>Reviewed by <b>" + rev2 + "</b></p>";
	
	var mediaType = props.reviewer1.mediaType;
	if (!mediaType && props.reviewer2) 
		mediaType = props.reviewer2.mediaType;
	if (mediaType == "film") mediaType = "Film";
	if (mediaType == "serial" || props.reviewer1.mediaId) mediaType = "TV";
	
	const birdColor = calculateColor(props.totalScore);
	

	return (
		<div className='align-left section-header white'>

			<h2 >
				<NavLink className='backtoreviews' to="/search">See All Reviews</NavLink>
			</h2>
				<div className="flex-col">
					<h1>{title}</h1>
					<h3>{mediaType}  • {props.reviewer1.year}</h3>	
				</div>	

				<div className='flex-item align-top gap-24'>
					<img src={require("../../data/" + props.title + "/" + props.title + ".jpg")} alt="" className='margin-4 rounded-corners' id='indv-poster'></img>
					<div className='flex-col gap-24'>
						<div className='flex-item gap-36' width={200}>
							<div>
								<img src={require('../images/' + birdColor + '.png')} alt="bird score icon" className='score-bird'></img>
								<div className={'score-value ' + birdColor}>{props.totalScore}</div>
							
							</div>
							<div>
								<h3 className='italic'>Characters and Cast Score: {props.ccScore}</h3>
								<h3 className='italic'>Bias and Reception Score: {props.brScore}</h3>
							</div>

						</div>
						<div className='flex-col gap-12'>
							<p style={{ whiteSpace: 'pre-wrap' }} 
							dangerouslySetInnerHTML={{ __html: quote1}}/>
							<p style={{ whiteSpace: 'pre-wrap' }} 
							dangerouslySetInnerHTML={{ __html: rev1}}/>
						</div>
							<div className='flex-col gap-12'>
								<p style={{ whiteSpace: 'pre-wrap' }} 
								dangerouslySetInnerHTML={{ __html: quote2}}/>
								<p style={{ whiteSpace: 'pre-wrap' }} 
								dangerouslySetInnerHTML={{ __html: rev2}}/>
								
							</div>
						<div>
							<h2>Bias Tags: {btString(props.biasTags)}</h2>
						</div>


					</div>

				</div>
		</div>
    )

}